import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthBackground from '../../components/AuthBackground';
import ScreenContainer from '../../components/ScreenContainer';
import TopBar from '../../components/TopBar';
import Heading from '../../components/Heading';
import Text from '../../components/Text';
import PasswordField from '../../components/PasswordField';
import Button from '../../components/Button';
import Toast from '../../components/Toast';
import api from '../../api';
import PasswordRules from '../../components/PasswordRules';

const NewPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const [passwords, setPasswords] = useState({ new: '', confirm: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const validatePassword = (password) => {
    return password.length >= 8 && /\d/.test(password) && /[a-zA-Z]/.test(password);
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!validatePassword(passwords.new)) {
      newErrors.new = 'Password must be at least 8 characters with letters and numbers';
    }
    if (passwords.new !== passwords.confirm) {
      newErrors.confirm = 'Passwords do not match';
    }
    
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      try {
        const response = await api.post('/accounts/auth/reset-password/', {
          email,
          new_password: passwords.new
        });
        
        if (response.data.success) {
          setToast({ type: 'success', message: 'Password updated successfully!' });
          setTimeout(() => {
            navigate('/auth/password-updated');
          }, 1500);
        }
      } catch (error) {
        const errorMessage = error.response?.data?.error || 'Failed to update password. Please try again.';
        setToast({ type: 'error', message: errorMessage });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <AuthBackground />
      <ScreenContainer>
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <TopBar 
            title="Set a new password" 
            onBack={() => navigate('/auth/verify-code', { state: { email } })}
          />
          <div className="mb-6">
            <Heading size="lg" className="mb-3">Create New Password</Heading>
            <Text>Create a new password. Ensure it differs from previous ones for security.</Text>
          </div>
          <div className="space-y-4">
            <div className="space-y-1">
              <PasswordField
                placeholder="New Password"
                value={passwords.new}
                onChange={(e) => setPasswords({...passwords, new: e.target.value})}
                error={errors.new}
              />
              <PasswordRules password={passwords.new} />
            </div>
            <PasswordField
              placeholder="Confirm Password"
              value={passwords.confirm}
              onChange={(e) => setPasswords({...passwords, confirm: e.target.value})}
              error={errors.confirm}
            />
            <Button 
              fullWidth
              onClick={handleSubmit}
              loading={loading}
              disabled={!passwords.new || !passwords.confirm}
            >
              Update Password
            </Button>
          </div>
        </div>
      </ScreenContainer>
      <Toast 
        message={toast?.message} 
        type={toast?.type}
        onClose={() => setToast(null)}
      />
    </>
  );
};

export default NewPassword;